import {MaterialType} from '@domain/material-storage'

export const TAB_CONFIG: {key: MaterialType; labelKey: string}[] = [
  {key: MaterialType.Cement, labelKey: 'tabs.cement'},
  {key: MaterialType.Clinker, labelKey: 'tabs.clinker'},
  {key: MaterialType.IntermediateAndFinishedProducts, labelKey: 'tabs.intermediate'},
  {key: MaterialType.RawMaterials, labelKey: 'tabs.rawMaterials'},
  {key: MaterialType.Fuels, labelKey: 'tabs.other'}
]
